import { Dispatch, SetStateAction } from "react";
import { Modal, TextField, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTemplate({ open, onClose, setOpen }: Props) {
  return (
    <Modal
      className="modal alertConfig_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Template</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label htmlFor="template-title">Title</label>
              <TextField
                id="template-title"
                fullWidth
                hiddenLabel
                placeholder="Enter Title"
              />
            </div>

            <div className="control_group">
              <label htmlFor="template-message">Message</label>
              <TextField
                id="template-message"
                fullWidth
                hiddenLabel
                placeholder="Enter Message"
                multiline
                rows={2}
              />
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
